export default __webpack_public_path__ + "static/media/customer-support.bd733c7e.png";